var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "instagram_1_",
    "data-name": "instagram (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M45.281,23.88H28.59a4.837,4.837,0,0,0-4.831,4.831V45.4a4.838,4.838,0,0,0,4.831,4.832H45.281A4.838,4.838,0,0,0,50.113,45.4V28.711A4.837,4.837,0,0,0,45.281,23.88ZM36.936,45.733a8.676,8.676,0,1,1,8.676-8.676A8.685,8.685,0,0,1,36.936,45.733Zm8.955-15.558a2.053,2.053,0,1,1,2.053-2.053A2.055,2.055,0,0,1,45.891,30.175Z",
    transform: "translate(-8.936 -8.981)",
    fill: "#f9ce62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M41.859,36.971a5.01,5.01,0,1,0,5.009,5.009A5.016,5.016,0,0,0,41.859,36.971Z",
    transform: "translate(-13.859 -13.905)",
    fill: "#f9ce62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M28,0A28,28,0,1,0,56,28,28,28,0,0,0,28,0ZM44.843,36.421a8.506,8.506,0,0,1-8.5,8.5H19.655a8.507,8.507,0,0,1-8.5-8.5V19.73a8.507,8.507,0,0,1,8.5-8.5H36.345a8.507,8.507,0,0,1,8.5,8.5Z",
    fill: "#f9ce62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.34f59c589849b684176a43e3890412e6.svg";
export { ForwardRef as ReactComponent };